import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import withExtendedTimeTracking from '../hoc/withExtendedTimeTracking';
import { toggleTimer } from '../actions';
import BarberHoverMenuTimeTrackingToggleButton from '../components/BarberHoverMenuTimeTrackingToggleButton';
import sideBySideShowForCurrentDay from '../hoc/sideBySideShowForCurrentDay';
import { getBarberUser } from '../../../auth/selectors';

const BarberHoverMenuTimeTrackingToggleButtonContainer = compose(
  sideBySideShowForCurrentDay,
  connect(
    state => ({
      barberUser: getBarberUser(state),
    }),
    { toggleTimer }
  ),
  withExtendedTimeTracking,
  withHandlers({
    onTimeTrackClick: props => () => {
      props.onTrackClick();
    },
  }),
)(BarberHoverMenuTimeTrackingToggleButton);

export default BarberHoverMenuTimeTrackingToggleButtonContainer;
